<script>
    import SubPageHeader from '../components/SubPageHeader.svelte'
    import WaitingPlaceholderBox from '../components/WaitingPlaceholderBox.svelte'
    import WaitingPlaceholderText from '../components/WaitingPlaceholderText.svelte'
    import Accordion from '../components/Accordion.svelte'

    import { onMount } from 'svelte';

    import { translations, current_lang } from '../stores.js';

    let content_id = 81;
    let get_content = null;

    let page_content = "";
    let img_content = "";
    let contentParts = [];
    let node;



    import {REST_getNodeBySlugAndLang} from '../wp-api/api.js';

	async function getBasicContent() {
		let content = await  REST_getNodeBySlugAndLang("syo-ja-juo", "fi");
        node = content;
        let temp_html = document.createElement("div");
        temp_html.innerHTML = content.content;

        let elements = temp_html.getElementsByTagName("img");
        for (let i = 0; i < elements.length; i++) {
            if(img_content == ""){
                elements[i].style.width = "100%";
                elements[i].style.height = "auto";
                elements[i].classList.add("not-available-offline");
                img_content += elements[i].outerHTML;
            }
            elements[i].parentNode.removeChild(elements[i]);
        }
        
        let fullPageHtml = content.content;

        if(temp_html.innerHTML.search("accordion index=") !== -1){
            if(node.acf){

                let remainingHtml = "";

                if(node.acf.accordions && node.acf.accordions.length > 0){
                    for(let i = 0; i < node.acf.accordions.length; i++){
                        let accordion = node.acf.accordions[i];

                        let accordionTagToSearch = '<!--[accordion index='+i+']-->';

                        if(fullPageHtml.indexOf(accordionTagToSearch) !== -1){
                            let fullPageHtmlSplit = fullPageHtml.split(accordionTagToSearch);
                            let contentWithAccordionSpace = [];

                            //poista splittiä edeltävä osa fullPageHtml:stä
                            fullPageHtml = fullPageHtml.replace(fullPageHtmlSplit[0], '');

                            //älä tuo mukaan jälkimmäistä osaa ennen, kuin lopuksi
                            
                            if(fullPageHtmlSplit.length == 2){
                                contentWithAccordionSpace = [
                                    {type: 'html', content: fullPageHtmlSplit[0]},
                                    {type: 'accordion', id: i},
                                    //{type: 'html', content: fullPageHtmlSplit[1]},
                                ];
                            }else{
                                contentWithAccordionSpace = [
                                    {type: 'accordion', id: i},
                                    //{type: 'html', content: fullPageHtmlSplit[1]},
                                ];
                            }

                            contentParts = contentParts.concat(contentWithAccordionSpace);
                            remainingHtml = fullPageHtmlSplit[1];
                        }
                    }
                }

                //lisää jäljelle jäänyt html mukaan
                if(remainingHtml != ""){
                    contentParts = contentParts.concat({type: 'html', content: remainingHtml});
                }
            }
        }

        page_content = temp_html.innerHTML;
	}

    // async function getBasicContent() {
	// 	const res = await fetch('https://porijazz.fi/fi/?option=com_pjwapi&task=apigetpublicarticle&article_id='+content_id);
	// 	if (res.ok) {
	// 		const content = await res.json();

    //         let temp_html = document.createElement("div");
    //         temp_html.innerHTML = content.introtext;

    //         let elements = temp_html.getElementsByTagName("img");
    //         for (let i = 0; i < elements.length; i++) {
    //             if(img_content == ""){
    //                 elements[i].style.width = "100%";
    //                 elements[i].style.height = "auto";
    //                 elements[i].classList.add("not-available-offline");
    //                 img_content += elements[i].outerHTML;
    //             }
    //             elements[i].parentNode.removeChild(elements[i]);
    //         }

    //         page_content = temp_html.innerHTML;
    //         return;
	// 	} else {
	// 		throw new Error(content);
	// 	}
	// }
    
    onMount(async () => {
        // if($current_lang == "FI"){
            
        // }
        // if($current_lang == "EN"){

        // }

        get_content = getBasicContent();
	});
</script>

<SubPageHeader page_title={$translations["EAT_AND_DRINK"][$current_lang]} />

<div class="content-container full">
    {#await get_content}
        <WaitingPlaceholderBox margin_bottom={0} />
        <div class="inner-padding-container">
            <WaitingPlaceholderText text_lines={8} />
            <WaitingPlaceholderText text_lines={8} />
        </div>
    {:then foo}
        <!-- {#if img_content != ""}
            {@html img_content}
        {/if}
        <div class="inner-padding-container">
            {#if page_content != ""}
                {@html page_content}
            {/if}
        </div> -->
        {#if contentParts.length > 0}
            <div class="inner-padding-container">
                {#if node && node.h1}
                    <h1>{@html node.h1}</h1>
                {/if}

                {#each contentParts as contentpart}
                    {#if contentpart.type == "accordion"}
                        <Accordion accordion={node.acf.accordions[contentpart.id].accordion} />
                    {/if}
                    {#if contentpart.type == "html"}
                        {@html contentpart.content}
                    {/if}
                {/each}
            </div>
        {:else}
            {#if img_content != ""}
                {@html img_content}
            {/if}
            <div class="inner-padding-container">
                {#if node && node.h1}
                    <h1>{@html node.h1}</h1>
                {/if}
                {#if page_content != ""}
                    {@html page_content}
                {/if}
            </div>
        {/if}
    {:catch error}
        <div class="inner-padding-container">
            {#if $current_lang == "FI"}
                <p>Sisällön lataaminen ei onnistunut. Ongelma voi johtua siitä, että laitteesi ei saa yhteyttä verkkoon.</p>
            {:else}
                <p>Could not load content. Your device may be offline.</p>
            {/if}
        </div>
    {/await}
</div>

<style>
h1{
    margin-top: 0;
}
:global(h3){
    margin-top: 30px;
}
</style>